import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { HeadingPriority } from "atoms/constants/heading-priority";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import Heading from "atoms/typography/heading";
import SectionRecord from "models/view-models/section-record";
import ShareSpaceItemRecord from "models/view-models/share-spaces/share-space-item-record";
import CollapsePanel from "molecules/collapse-panel/collapse-panel";
import React from "react";
import { useHistory } from "react-router";
import { useGlobalState } from "utilities/contexts/use-global-state-context";
import { t } from "utilities/localization-utils";

interface ShareSpaceItemDisplayProps {
    item: ShareSpaceItemRecord;
}

const CSS_BASE_CLASS = "c-share-space-item-display";

const ShareSpaceItemDisplay: React.FC<ShareSpaceItemDisplayProps> = ({
    item,
}) => {
    const { push } = useHistory();
    const { isAuthenticated } = useGlobalState();

    const bookviewRoute = item.section?.getRoute(item.publication?.type);

    const handleOnBookviewClick = () => {
        push(bookviewRoute!);
    };
    const PanelTop = () => {
        return (
            <header className={`${CSS_BASE_CLASS}__header`}>
                <div className={`${CSS_BASE_CLASS}__headerText`}>
                    <Heading
                        priority={HeadingPriority.Four}
                        cssClassName={`${CSS_BASE_CLASS}__title`}>
                        {item.section?.getFullyQualifiedDisplayTitle()}
                    </Heading>
                    <Heading
                        priority={HeadingPriority.Five}
                        cssClassName={`${CSS_BASE_CLASS}__publication`}>
                        {item.publication?.getDisplayTitle()}
                    </Heading>
                </div>
                {isAuthenticated && bookviewRoute && (
                    <Button
                        size={ButtonSizes.Small}
                        onClick={handleOnBookviewClick}
                        cssClassName={`${CSS_BASE_CLASS}__bookviewButton`}
                        style={ButtonStyles.Secondary}>
                        <Icon type={Icons.OpenBook} />
                        {t("openInBookView")}
                    </Button>
                )}
            </header>
        );
    };

    const displaySubSections = (
        subSection: SectionRecord | null
    ): JSX.Element | null => {
        if (!subSection) return null;
        return (
            <section
                key={subSection.id}
                className={`${CSS_BASE_CLASS}__body__subsection`}
                id={`${subSection.id}`}>
                {subSection?.getTitle()}
                {subSection?.getBody()}
                {subSection.subSections?.map((child) => {
                    return child ? displaySubSections(child) : null;
                })}
            </section>
        );
    };

    return (
        <CollapsePanel
            iconSize={IconSizes.Base}
            modifierCSSClassName={CSS_BASE_CLASS}
            buttonAriaText={""}
            collapse={true}
            useToggleOnRight
            panelTop={<PanelTop />}>
            <section className={`${CSS_BASE_CLASS}__body`}>
                {item.section?.getBody()}
                {item.subSections?.map((subSection) => {
                    return subSection ? displaySubSections(subSection) : null;
                })}
            </section>
        </CollapsePanel>
    );
};

export default ShareSpaceItemDisplay;
